import { Component, ViewChild, ElementRef } from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import { SocketProvider } from '../../providers/socket/socket';
import { WaitPage } from '../wait/wait';

@Component({
  selector: 'page-snap',
  templateUrl: 'snap.html'
})
export class SnapPage {
  @ViewChild('myCanvas') myCanvas: ElementRef;
  @ViewChild('myVideo') myVideo: ElementRef;
  public context: CanvasRenderingContext2D;
  video;
  canvasWidth;
  canvasHeight;
  prompt;

  constructor(public navCtrl: NavController, private socketProvider: SocketProvider, private navParams: NavParams) {
    if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
          this.video = stream;
      });
    }
    this.prompt = this.navParams.get('prompt');
  }

  takePic() {
      this.context = (<HTMLCanvasElement>this.myCanvas.nativeElement).getContext('2d');
      this.context.drawImage(this.myVideo.nativeElement, -125, -90, 400, 300);
      const  data = this.myCanvas.nativeElement.toDataURL('image/png');
      this.socketProvider.sendMessage({
        action:'snap',
        image: data,
        slot: this.navParams.get('slot')
      });
      this.video.getTracks()[0].stop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/snap/snap.ts